
export { button } from "/vercel/path0/styled-system/recipes/button.mjs"